import axios from "./axiosinstance";

const DispositionApi = {
  add: (payload) => axios.post("dispositions/add", payload),
  list: () => axios.get("dispositions/list"),
  update: (payload) => axios.post("dispositions/update", payload),
  delete: (payload) => axios.post("dispositions/delete", payload),
};

export default DispositionApi;